export default __webpack_public_path__ + "static/eocp-staff-c49c5aa878d9bcc2724878b00853be1c.jpg";